import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { DescriptionOutlined, History } from '@material-ui/icons';
import { fetchBrandConfigModulesPack } from 'actions/Brands';
import DataGrid from 'components/DataGrid/DataGrid';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import InfoModal from 'components/InfoModal/InfoModal';
import LogView from 'components/History/LogView';
import { isGranted } from 'helpers/helpers';
import { ROLE_CREATE_ORDER } from 'helpers/roles';

import getColumnConfig from './ordersColumnConfig';

const Orders = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id: userId } = useParams();
  const { t } = useTranslation();

  const { selectedBrand } = useSelector(({ Auth }) => Auth);

  const [orderHistoryId, setOrderHistoryId] = useState(null);
  const [receiptSharingMethod, setReceiptSharingMethod] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const gridRef = useRef(null);

  const fillModal = content => setModalContent(content);

  useEffect(() => {
    (async () => {
      try {
        const {
          configuration: { Fakturownia },
        } = await dispatch(
          fetchBrandConfigModulesPack(selectedBrand, ['Fakturownia'])
        );

        setReceiptSharingMethod(Fakturownia.receiptSharingMethod);
        // eslint-disable-next-line no-empty -- FIXME
      } catch {}
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  return (
    <>
      <div>
        {isGranted(ROLE_CREATE_ORDER) && (
          <FormControlButtons
            handleSubmit={() => {
              history.push(`/admin/orders/add?userId=${userId}`);
            }}
            submitText={t('clients.newOrder')}
          />
        )}
        <DataGrid
          ref={gridRef}
          refreshOnFetch={true}
          actions={true}
          paginationTop={true}
          paginationBottom={false}
          minRows={18}
          url="/orders"
          reportName="order"
          role="ORDER"
          columns={getColumnConfig(fillModal)}
          customActions={row => [
            {
              action: props => {
                window.open(
                  receiptSharingMethod === 'PDF'
                    ? props.row.invoicePDF
                    : props.row.invoicePDF.replace(/\.pdf$/, ''),
                  '_blank'
                );
              },
              icon: row.invoicePDF ? <DescriptionOutlined /> : null,
              disabled: row.invoicePDF === null,
              color: row.invoicePDF ? 'primary' : 'tumblr',
              buttonText: row.invoicePDF
                ? t('accountingDocument')
                : t('noAccountingDocument'),
              simple: true,
              round: false,
              style: {
                width: 'max-content',
              },
            },
            {
              action: props => {
                setOrderHistoryId(props.row['@id']);
              },
              icon: <History />,
              disabled: false,
              color: 'warning',
              buttonText: t('orders.orderHistory'),
              simple: true,
              round: false,
              style: {
                width: 'max-content',
              },
            },
          ]}
          customActionsWidth={200}
          manipulateQuery={(requestData, query) => {
            if (query.createdAt) {
              const filters = query.createdAt;

              delete query.createdAt;

              if (filters.after) {
                query['createdAt[after]'] = filters.after;
              }
              if (filters.before) {
                query['createdAt[before]'] = filters.before;
              }
            }
            if (query.priceAfterDiscount) {
              const filters = query.priceAfterDiscount;

              delete query.priceAfterDiscount;

              if (filters.valueFrom) {
                query['priceAfterDiscount[gte]'] = filters.valueFrom;
              }
              if (filters.valueTo) {
                query['priceAfterDiscount[lte]'] = filters.valueTo;
              }
            }

            query['client.id[]'] = userId;

            return query;
          }}
        />
      </div>
      <InfoModal
        modalState={!!orderHistoryId || !!modalContent}
        handleClose={() => {
          setOrderHistoryId(null);
          setModalContent(null);
        }}
        modalContent={
          modalContent ||
          (orderHistoryId ? (
            <LogView iri={orderHistoryId} historyOpenDefault={true} />
          ) : null)
        }
        closeButtonText={t('form.close')}
      />
    </>
  );
};

export default Orders;
